module.exports = __webpack_public_path__ + "static/scale-model-of-beaver-brook-park-in-worcester-massachusetts-d58831b4ca38edfccec1a62069fd06e6.png";